import { render } from "./toggleStatusPopup.vue?vue&type=template&id=6864481a&scoped=true"
import script from "./toggleStatusPopup.vue?vue&type=script&lang=js"
export * from "./toggleStatusPopup.vue?vue&type=script&lang=js"

import "./toggleStatusPopup.vue?vue&type=style&index=0&id=6864481a&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6864481a"]])

export default __exports__